import { PepMatchRecord } from '../pep-match.model';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { PoliticallyExposed } from 'app/shared/models/politically-exposed.model';
import { EntityType } from 'app/shared/models/entity-id-details.model';

/**
 * Service for Monitoring Politically Exposed Information Details card.
 */
@Injectable()
export class PoliticallyExposedService {
    addPEPMatch: EventEmitter<string> = new EventEmitter();

    constructor(private requestService: ObservableRequestService) { }

    getPoliticallyExposedInfoMatchDesc(entityId: number, entityType: EntityType): Observable<any> {
        const politicallyExposedMatchDescUri = ConstantsService.MONITORING_PEP_MATCH_SERVICES + '/' + entityId;
        return this.requestService.getRequest(politicallyExposedMatchDescUri).map(response => {
            return response.arrResult || { suggestionList: [] };
        });
    }

    /**
     * Fetch a single PEP match with full details (including description).
     * Used when user expands a row to avoid loading large descriptions in the list.
     */
    getPepMatchDetail(entityId: number, pepEntityId: number): Observable<any> {
        const uri = ConstantsService.MONITORING_PEP_MATCH_SERVICES + '/' + entityId + '/match/' + pepEntityId;
        return this.requestService.getRequest(uri).map(response => response.arrResult);
    }

    updatePoliticallyExposedDescription(elaborationTextSaveData: PoliticallyExposed, entityType: string): Observable<any> {
        const generalInfoSavePath = (entityType.toLocaleLowerCase() === 'person') ?
            ConstantsService.ENTITY_PERSON_GENERAL_INFO_SERVICES :
            ConstantsService.ENTITY_ORG_GENERAL_INFO_SERVICES;
        return this.requestService.putRequest(generalInfoSavePath,
            JSON.stringify(elaborationTextSaveData),
            this.requestService.getJSONContentType());
    };

    addPoliticallyExposedMatch(pepMatch: PepMatchRecord, entityId: number): Observable<any> {
        const politicallyExposedMatchDescUri = ConstantsService.MONITORING_PEP_MATCH_SERVICES + '/' + entityId;
        return this.requestService.postRequest(politicallyExposedMatchDescUri,
            JSON.stringify(pepMatch),
            this.requestService.getJSONContentType());
    };

    markPepResolve(pepMatchRecord: PepMatchRecord) {
        const badPressResolveURL = ConstantsService.RESOLVE_PEP;
        return this.requestService.putRequest(badPressResolveURL,
            JSON.stringify(pepMatchRecord),
            this.requestService.getJSONContentType());
    }

    addPepMatchEvent(event) {
        this.addPEPMatch.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/politicallyexposed/politically-exposed.service.ts